import React, { Component } from 'react'
import RefreshIndicator from 'material-ui/RefreshIndicator'
import AccountCircle from 'material-ui/svg-icons/action/account-circle'
import FlatButton from 'material-ui/FlatButton'
import { t } from '@billes/translator-client'
import { connect } from 'cerebral-view-react'
import { Notification } from 'react-notification'

class SaveButton extends Component {
  saveAccount() {
    const { signals } = this.props
    signals.user.saveAccount()
  }

  onDismiss() {
    const { signals } = this.props
    signals.user.unShowSaveUserSnackbar()
  }

  renderSubmittingButton() {
    const { float, left } = this.props
    return (
      <div style={{ float, position: 'relative', fontSize: 13 }}>
        <RefreshIndicator
          size={30}
          left={left}
          top={-10}
          status={'loading'}
          loadingColor={'#72ccb3'}
        />
      </div>
    )
  }

  renderSaveButton() {
    const { float } = this.props
    return (
      <FlatButton
        onClick={e => this.saveAccount(e)}
        style={{ float, color: '#a8a8a8' }}
        label={t('common.save')}
        labelStyle={{ fontSize: 13, marginLeft: -5 }}
        labelPosition={'after'}
        icon={<AccountCircle viewBox={'0 0 20 30'} />}
      />
    )
  }

  render() {
    const { forms: { isSubmitting, snackbar: { show, success } } } = this.props

    let button =
      isSubmitting || show
        ? this.renderSubmittingButton()
        : this.renderSaveButton()
    return (
      <div style={{ paddingTop: 20, paddingBottom: 10 }}>
        {button}
        <Notification
          isActive={show}
          message={t(
            success ? 'bus-client.userSaved' : 'bus-client.userSaveFail'
          )}
          onDismiss={() => this.onDismiss()}
          dismissAfter={success ? 1500 : 3000}
          barStyle={{ backgroundColor: success ? '#72ccb3' : 'red' }}
        />
      </div>
    )
  }
}
SaveButton.defaultProps = {
  float: 'right',
  left: -40
}

export default connect({
  forms: 'client.forms',
  locale: 'client.selectedLocale'
})(SaveButton)



// WEBPACK FOOTER //
// ./src/components/User/ChangeNavigation/saveButton.js